export { paginationPlugin } from './src/index';
